
	import { Component, Vue } from 'vue-property-decorator';
	import aps from '@/HostApp/store/ApsModules/ApsModule';
	import ViewportWrapper from '@/HostApp/ui/system/ViewportWrapper.vue';

	@Component({
		components: {
			ViewportWrapper
		}
	})
	export default class TheWizardSteps extends Vue {
		protected get activeStep(): number {
			return aps.wizard.activeStep;
		}

		protected get currentStep(): number {
			const { steps } = aps.wizard;
			const activeItem = steps?.[this.activeStep];

			return activeItem ? this.wizardSteps.findIndex((item) => item.id === activeItem.id) + 1 : 0;
		}

		protected get isWizardActive(): boolean {
			return aps.wizard.active;
		}

		protected get stepTitles(): Common.IMap<string> {
			return this.wizardSteps.reduce((acc, item) => {
				acc[item.id] = this.$t(item['step-label'] || item.label || '');

				return acc;
			}, {} as Common.IMap<string>);
		}

		protected get wizardSteps(): Array<APS.IWizardState> {
			const { steps } = aps.wizard;

			return steps?.filter((item) => item.visible) || [];
		}

		protected get viewTitle(): string {
			const { view } = aps.wizard;

			return view['step-label'] || view.label;
		}
	}
